const EMOJI_PATTERN = new RegExp("\\p{Extended_Pictographic}|\\p{Regional_Indicator}", "u");
const SVG_PATTERN = /^(?:<\?xml[^>]*\?>\s*)?(?:<!--[\s\S]*?-->\s*|<!DOCTYPE[^>]*>\s*)*<svg[\s>][\s\S]*<\/svg>$/i;

export const SVG_MAX_BYTES = 102400;
export const NAME_MAX_LENGTH = 100;

export function sortByPosition(tiers) {
  return [...(tiers || [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
}

export function withPositions(orderedTiers) {
  return orderedTiers.map((tier, index) => ({ ...tier, position: index }));
}

export function rewardsOfTier(rewards, tierId) {
  if (!tierId) return [];
  return (rewards || []).filter((reward) => (reward.tierIds || []).includes(tierId));
}

export function firstEmoji(text) {
  const value = String(text || "").trim();
  if (!value) return "";

  const graphemes = typeof Intl !== "undefined" && Intl.Segmenter
    ? Array.from(new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(value), (part) => part.segment)
    : Array.from(value);

  return graphemes.find((grapheme) => EMOJI_PATTERN.test(grapheme)) || "";
}

export function svgToDataUri(svg) {
  return svg ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}` : "";
}

export function tierSelectOptions(tiers) {
  return sortByPosition(tiers).map((tier) => ({
    value: tier.id,
    label: tier.name,
    svgSource: tier.iconType === "svg" ? svgToDataUri(tier.iconSvg) : "",
    emoji: tier.iconType === "emoji" ? tier.iconEmoji : "",
    chipStyle: {
      background: tier.color || "#b45f24",
      color: tier.textColor || "#fcfcfd",
    },
  }));
}

export function readSvgFile(file) {
  return new Promise((resolve, reject) => {
    if (file.size > SVG_MAX_BYTES) {
      reject(new Error("svg-too-large"));
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const content = String(reader.result || "").trim();
      if (SVG_PATTERN.test(content)) {
        resolve(content);
      } else {
        reject(new Error("invalid-svg"));
      }
    };
    reader.onerror = () => reject(new Error("invalid-svg"));
    reader.readAsText(file);
  });
}
